import { PortalTeamsAppInstallations } from '@features/portal-tools/sub-features/teams-administration/components/PortalTeamsAppInstallations'
import { hasPermission } from '@features/rbac/permissions'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_layout/admin/teams-app-installations')({
    beforeLoad: async () => {
        if (!hasPermission('teams.manage')) {
            throw redirect({ to: '/unauthorised' })
        }
    },
    component: PortalTeamsAppInstallations,
})
